const sw = {
  nav_dashboard: 'Dashibodi', nav_inventory: 'Hesabu ya Bidhaa', nav_my_stock: 'Hisa Yangu',
  nav_containers: 'Makontena', nav_requests: 'Maombi', nav_invoices: 'Ankara',
  nav_payments: 'Malipo', nav_settings: 'Mipangilio', nav_sign_out: 'Ondoka',
  nav_customers: 'Wateja', nav_employees: 'Wafanyakazi', nav_tasks: 'Kazi',
  nav_scan: 'Changanua', nav_pricing: 'Bei', nav_price_quotes: 'Makadirio',
  nav_selection_orders: 'Maagizo ya Uchaguzi',
  btn_save: 'Hifadhi', btn_cancel: 'Ghairi', btn_delete: 'Futa', btn_edit: 'Hariri',
  btn_add: 'Ongeza', btn_submit: 'Wasilisha', btn_approve: 'Idhinisha', btn_reject: 'Kataa',
  btn_search: 'Tafuta', btn_confirm: 'Thibitisha', btn_sign_in: 'Ingia',
  login_title: 'BIG STAR', login_subtitle: 'Usimamizi wa Usafirishaji wa Magari',
  login_username: 'Jina la mtumiaji', login_email: 'Barua pepe', login_password: 'Nywila',
  login_remember: 'Nikumbuke', login_invalid: 'Taarifa za kuingia si sahihi',
  detail_make: 'Mtengenezaji', detail_model: 'Aina', detail_year: 'Mwaka',
  detail_chassis: 'Nambari ya Chasis', detail_color: 'Rangi', detail_mileage: 'Maili',
  detail_condition: 'Hali', detail_status: 'Hali', detail_price: 'Bei',
  status_available: 'Inapatikana', status_shipped: 'Imetumwa',
  status_delivered: 'Imefikishwa', status_pending: 'Inasubiri',
  vehicles: 'Magari', engines: 'Injini', parts: 'Vipuri', dashboard: 'Dashibodi',
  add: 'Ongeza', edit: 'Hariri', save: 'Hifadhi', cancel: 'Ghairi', search: 'Tafuta',
  noData: 'Hakuna data', dash_welcome: 'Karibu, {name}',
  dash_total_fob: 'Jumla ya Thamani ya FOB',
  dash_late_night: 'Usiku mzuri', dash_hello: 'Habari',
  dash_subtitle: 'Muhtasari wa magari yako, vipuri, na mizigo inayokuja — inasasishwa moja kwa moja.',
  dash_local_time: 'SAA YA HAPA', dash_status: 'HALI', dash_all_systems_live: 'Mifumo yote inafanya kazi',
  dash_view_recommendations: 'Angalia mapendekezo', dash_my_stock: 'HISA YANGU', dash_in_transit: 'NJIANI',
  dash_units: 'vitengo', dash_containers: 'makontena', dash_browse_more: 'Tazama zaidi',
  dash_track_shipments: 'Fuatilia mizigo', dash_browse_inventory_start: 'Vinjari hesabu ya bidhaa kuanza',
  dash_no_active_shipments: 'Hakuna mizigo inayoendelea', dash_next_eta: 'Muda wa kuwasili', dash_days: 'siku',
  dash_etas_confirming: 'Nyakati za kuwasili zinathibitishwa', dash_this_week: 'WIKI HII',
  dash_arriving_soon: 'INAKUJA HIVI KARIBUNI', dash_logistics: 'USAFIRISHAJI', dash_active_shipments: 'Mizigo inayoendelea',
  dash_view_all: 'Tazama yote', dash_shipment_empty: 'Mizigo yako itaonekana hapa vitengo vinapopakiwa kwenye kontena',
  dash_composition: 'MUUNDO', dash_stock_breakdown: 'Mgawanyo wa hisa', dash_no_units_yet: 'Bado hakuna vitengo',
  dash_browse_to_build: 'Vinjari hesabu ya bidhaa kujenga hisa yako',
  dash_for_you: 'KWA AJILI YAKO', dash_picked_based: 'Imechaguliwa kulingana na hisa yako', dash_browse_all: 'Vinjari yote',
  dash_picking_units: 'Tunakuchagulia vitengo. Rudi hivi karibuni au vinjari hesabu yote',
  dash_view_details: 'Tazama maelezo', dash_just_arrived: 'IMEFIKA HIVI KARIBUNI', dash_similar: 'INAFANANA NA YAKO',
  dash_today: 'Leo', dash_tomorrow: 'Kesho',
};
export default sw;
